// extracted by css-extract-rspack-plugin
module.exports =  {"root":"SectionEmptyState__root___Ad78t","title":"SectionEmptyState__title___fqJbd","subtitle":"SectionEmptyState__subtitle___U7Rxm"};